// Load and parse the regions CSV file
let regionsGeoJSON = null;

// Parse WKT POLYGON to GeoJSON coordinates
function parseWKTPolygon(wkt) {
  // Extract coordinates from WKT format: "POLYGON ((lon lat, lon lat, ...))"
  const coordsMatch = wkt.match(/POLYGON\s*\(\((.*?)\)\)/);
  if (!coordsMatch) return null;
  
  const coordsString = coordsMatch[1];
  const coordinates = coordsString
    .split(',')
    .map(pair => {
      const [lon, lat] = pair.trim().split(/\s+/);
      return [parseFloat(lon), parseFloat(lat)];
    })
    .filter(coord => !isNaN(coord[0]) && !isNaN(coord[1]));
  
  // GeoJSON Polygon needs array of rings, and should be closed (first point = last point)
  return [coordinates];
}

export async function loadRegionsGeoJSON() {
  if (regionsGeoJSON) return regionsGeoJSON;
  
  try {
    const response = await fetch('/regioncsv/COEMS Regions- Untitled layer.csv');
    const csvText = await response.text();
    
    // Parse CSV - handle multiline values properly
    const lines = csvText.split('\n');
    const features = [];
    
    let i = 1; // Skip header row
    while (i < lines.length) {
      let line = lines[i].trim();
      if (!line) {
        i++;
        continue;
      }
      
      // If line starts with quote, keep reading until we find the closing quote
      if (line.startsWith('"')) {
        while (!line.match(/"\s*,/) && i < lines.length - 1) {
          i++;
          line += ' ' + lines[i].trim();
        }
      }
      
      // Parse CSV line - extract WKT, name, description
      const wktMatch = line.match(/^"([^"]+)"/);
      if (!wktMatch) {
        i++;
        continue;
      }
      
      const wkt = wktMatch[1];
      const afterWkt = line.substring(wktMatch[0].length + 1); // +1 for comma
      const parts = afterWkt.split(',');
      const name = parts[0] ? parts[0].trim() : '';
      const description = parts[1] ? parts[1].trim() : '';
      
      const coordinates = parseWKTPolygon(wkt);
      
      if (coordinates && coordinates[0].length > 0) {
        features.push({
          type: 'Feature',
          properties: {
            name: name,
            description: description
          },
          geometry: {
            type: 'Polygon',
            coordinates: coordinates
          }
        });
      }
      
      i++;
    }
    
    regionsGeoJSON = {
      type: 'FeatureCollection',
      features: features
    };
    
    console.log(`Loaded ${features.length} regional boundaries`);
    return regionsGeoJSON;
    
  } catch (error) {
    console.error('Error loading regions:', error);
    return null;
  }
}
